module.exports = __webpack_public_path__ + "media/images/landing_page/2023/main_home_image_mob-9c76b2210064aa9856f5aa2b2b7d6a70.png";